module.exports = __webpack_public_path__ + "img/student_image.217a04eb.jpg";